module.exports = __webpack_public_path__ + "fonts/TTNormsPro-BlackItalic.b0ee13c0.woff";